// import React, { useEffect, useRef, useState } from "react";
// import MarqueeBar from "./MarqueeBar";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { getprofile } from "../../Redux/AllApi/action";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MarqueeBar from "./MarqueeBar";
import { allapiAction } from "../../Redux/common/action";
/* 🔥 UPGRADE IMAGES */
const upgradeImages = [
  "/img/upgradenow.png",
  "/img/District.png",
  "/img/Pincode.png",
];


function NewBox() {


  // ✅ DISPATCH DEFINE
  const dispatch = useDispatch();

  // ✅ MARQUEE API CALL (COMPONENT KE ANDAR)
  useEffect(() => {
    dispatch(allapiAction.getMarqueesList2({ page: "home" }));
  }, [dispatch]);



 // ✅ MARQUEE DATA FETCH
  useEffect(() => {
    dispatch(allapiAction.getMarqueesList2({ page: "home" }));
  }, [dispatch]);

  const wrapperRef = useRef(null);
  const sourceRef = useRef(null);
  const potRef = useRef(null);

  const [coins, setCoins] = useState([]);

  /* 🔥 IMAGE SWITCHER STATE */
  const [upgradeIndex, setUpgradeIndex] = useState(0);

  const changeUpgradeImage = () => {
    setUpgradeIndex((prev) => (prev + 1) % upgradeImages.length);
  };

  /* 🔥 COIN ANIMATION (UNCHANGED) */
  useEffect(() => {
    const interval = setInterval(() => {
      if (!wrapperRef.current || !sourceRef.current || !potRef.current) return;

      const wrap = wrapperRef.current.getBoundingClientRect();
      const src = sourceRef.current.getBoundingClientRect();
      const pot = potRef.current.getBoundingClientRect();

      const sx = src.right - wrap.left - 15;
      const sy = src.top + src.height / 2 - wrap.top;

      const dx = pot.left + pot.width / 2 - wrap.left - sx;
      const dy = pot.top + pot.height / 2 - wrap.top - sy;

      setCoins((prev) => [
        ...prev.slice(-6),
        {
          id: Date.now() + Math.random(),
          x: sx,
          y: sy,
          dx,
          dy,
        },
      ]);
    }, 700);

    return () => clearInterval(interval);
  }, []);

  const navigate = useNavigate();

  const deshboard = useSelector((state) =>
    state?.allapi?.deshboard ? state.allapi.deshboard : {}
  );

  const totalIncome =
    (deshboard?.bounseIncomes || 0) +
    (deshboard?.directincome || 0) +
    (deshboard?.gapingIncomes || 0) +
    (deshboard?.lavelIncomes || 0) +
    (deshboard?.matchingIncomes || 0) +
    (deshboard?.reMatchingIncomes || 0) +
    (deshboard?.redirectincome || 0) +
    (deshboard?.bounseIncomes || 0);

  const businessGrowthBenefit =
    (deshboard?.bounseIncomes || 0);

  return (
    <div className="unisckse-box-wrapper pb-4" ref={wrapperRef}>
      <MarqueeBar />

      <div className="row g-2 align-items-center">
        {/* 1 CRORE CARD */}
        <div className="col-6 col-lg-3 px-1 mb-4">
          <div className="card crore-card" ref={sourceRef}>
            <div className="big-amount text-color-deshboard">First Target</div>
            <div className="big-amount text-color-deshboard">10000000</div>
            <div className="hindi-amount text-color-deshboard">एक करोड़</div>
          </div>
        </div>

        {/* POT CARD */}
        <div className="col-6 col-lg-3 px-1 mb-4">
          <div className="card pot-card" ref={potRef}>
            <img src="/img/Portimg.png" alt="pot" className="pot-img" />
            <div className="pot-text">{totalIncome}</div>
          </div>
        </div>

        {/* UPGRADE */}
        <div className="col-6 col-lg-3 px-1 mb-4">
          <div className="card upgrade-card2">
            <div className="card-inner">
              <div className="card-title text-center text-color-deshboard">Repurchase </div>
              <div className="card-subtitle text-center text-color-deshboard">Growth Credit</div>
              <div className="card-subtitle text-center text-color-deshboard">
                {businessGrowthBenefit}
              </div>
              <div className="card-glow"></div>
            </div>
          </div>
        </div>

        {/* 🔥 REBOOT INCOME (IMAGE SWITCHER) */}
        <div className="col-6 col-lg-3 px-1 mb-4">
          <div className="card upgrade-card" style={{ position: "relative" }}>
            <img
              src={upgradeImages[upgradeIndex]}
              alt="upgradenow"
              className="pot-card rounded-0"
            />

            <button
              onClick={changeUpgradeImage}
              style={{
                position: "absolute",
                top: "6px",
                right: "6px",
                fontSize: "10px",
                padding: "2px 6px",
                background: "rgba(0,0,0,0.6)",
                color: "#fff",
                border: "none",
                borderRadius: "3px",
                cursor: "pointer",
              }}
            >
              Change
            </button>
          </div>
        </div>
      </div>

      {/* COINS */}
      <div className="coin-layer">
        {coins.map((c) => (
          <img
            key={c.id}
            src="/img/coin.png"
            className="coin"
            style={{
              left: c.x,
              top: c.y,
              "--dx": `${c.dx}px`,
              "--dy": `${c.dy}px`,
            }}
            onAnimationEnd={() =>
              setCoins((p) => p.filter((x) => x.id !== c.id))
            }
            alt=""
          />
        ))}
      </div>
    </div>
  );
}

export default NewBox;
